import React, { useEffect } from 'react';
import Animated from 'components/generals/AnimatedComponent';
import Calculator from 'components/generals/calculator';
import picture_1 from 'assets/images/home/section_10/pict_1.jpg';
import picture_2 from 'assets/images/home/section_10/pict_2.png';
import picture_3 from 'assets/images/home/section_10/pict_3.jpg';

export default function Home__section__10() {
    return (
        <main className="nv__section nv__section--no-margin nv__hp__section__10">
            <section className="nv__section__container">
                <Animated animation={'animate__fadeInDown animate__delay-1s'}>
                    <h1>Calcula tu aportación y tus beneficios</h1>
                </Animated>

                <Animated animation={'animate__fadeInDown animate__delay-2s'}>
                    <div className="nv__blocks__hectareas">
                        <div className="nv__blocks__hectareas__item">
                            <div className="nv__blocks__hectareas__container">
                                <div className="nv__blocks__hectareas__item__image nv__blocks__hectareas__item__image--1"></div>
                                <h3>
                                    1/2 <br /> HECTÁREA
                                </h3>
                                <p>9,000 plantas</p>
                                <p>$247,500</p>
                            </div>
                        </div>

                        <div className="nv__blocks__hectareas__item">
                            <div className="nv__blocks__hectareas__container">
                                <div className="nv__blocks__hectareas__item__image nv__blocks__hectareas__item__image--2"></div>
                                <h3>
                                    1 <br />
                                    HECTÁREA
                                </h3>
                                <p>18,000 plantas</p>
                                <p>$549,000</p>
                            </div>
                        </div>

                        <div className="nv__blocks__hectareas__item">
                            <div className="nv__blocks__hectareas__container">
                                <div className="nv__blocks__hectareas__item__image nv__blocks__hectareas__item__image--3"></div>
                                <h3>
                                    1/4 <br /> HECTÁREA
                                </h3>
                                <p>4,500 plantas</p>
                                <p>$137,500</p>
                            </div>
                        </div>
                    </div>
                </Animated>
            </section>
        </main>
    );
}
